var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0352 8.7147C17.6935 8.37299 17.1395 8.37299 16.7978 8.7147L12.1311 13.3814C11.7894 13.7231 11.7894 14.2771 12.1311 14.6188L16.7978 19.2855C17.1395 19.6272 17.6935 19.6272 18.0352 19.2855C18.3769 18.9438 18.3769 18.3897 18.0352 18.048L13.9873 14.0001L18.0352 9.95213C18.3769 9.61042 18.3769 9.05641 18.0352 8.7147Z",
    fill: "#071E0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretLeft);
export default __webpack_public_path__ + "static/media/caret-left.aed2d906b5d9888eaa4d53497e1fdb5b.svg";
export { ForwardRef as ReactComponent };